import React, {PropTypes} from 'react';
import {Checkbox, Button} from '@goguardian/based';

import style from './style.scss';

export default class Terms extends React.Component {

  render() {

    return (
      <div className={style.termsContainer}>
        <h1>Terms & Conditions</h1>
        <div className={style.termsRow}>
          <Checkbox/>
          <span className={style.termsAgreement}>
            I agree to the <a href="https://www.goguardian.com/policies/eula">Terms of Service</a> and <a href="https://www.goguardian.com/policies/privacy">Privacy Policy</a>
          </span>
        </div>
        <Button>
          Continue
        </Button>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/terms/index.jsx
 **/